export const manifesto = {
  line: 'Most people build brands that bore people to death, we don’t.',
  /** The same line split for phones: first half, second (slightly longer) half */
  lineMobile: ['Most people build brands that', 'bore people to death, we don’t.'],
  heading: ['We build brands', 'that move people'],
};
